/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ActionsObservable, StateObservable } from 'redux-observable';
import { isOfType } from 'typesafe-actions';
import { filter, map, mergeMap } from 'rxjs/operators';
import { catchError } from 'rxjs/internal/operators/catchError';
import { from, of } from 'rxjs';

import {
  updateCartItemSuccess,
  updateCartItemFailure,
  UpdateCartItemAction,
  UpdateCartItemActionTypes,
} from '../actions/UpdateCartItem';
import { IErrorActionData } from '../../../models/Error';
import RootState from '../../../config/store/RootState';
import RootAction from '../../../config/store/RootAction';
import updateCartItemService from '../services/UpdateCartItem';

const UpdateCartItemEpic = (action$: ActionsObservable<RootAction>, state$: StateObservable<RootState>) => action$.pipe(
  filter(isOfType(UpdateCartItemActionTypes.UPDATE_CART_ITEM)),
  mergeMap((action: UpdateCartItemAction) => from(
    updateCartItemService(
      action.payload.updateCartItem,
      action.payload.cartAliasId,
      action.payload.cartItemAliasId,
    ),
  ).pipe(
    map((response) => updateCartItemSuccess()),
    catchError((error: IErrorActionData) => of(
      updateCartItemFailure({
        errorCode: error.errorCode || 500,
        errorMessage: error.errorMessage,
        callBack: error.callBack,
      }),
    )),
  )),
);

export default UpdateCartItemEpic;
